<div class="status-indicator">
  <a class="status-indicator__dot" [ngClass]="statusIndicator | lowercase" [matTooltip]="tooltipMessage"></a>
  <span class="status-indicator__label"> Algorithm </span>
</div>
